<div class="tooltip" #chatMessageTooltip>
  <svg class="tooltip-arrow" width="8" height="14" viewBox="0 0 8 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8 0V14L0 7L8 0Z" fill="#131313" />
  </svg>
  <p [innerHtml]="message | name | chatEmote : userLevel"></p>
</div>
